// removed by extract-text-webpack-plugin
module.exports = {"container":"Notifier__container___3uMTV","error_container":"Notifier__error_container___2V9f6","message":"Notifier__message___bWqLo","message_error":"Notifier__message_error___1UpJH","close":"Notifier__close___35RWE","img":"Notifier__img___3RNfP","show":"Notifier__show___3j50B"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/views/widgets/Notifier.css
 ** module id = 713
 ** module chunks = 0
 **/